import { FormControl, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { IWeather } from "schedule/model"

interface IWeatherSelectProps {
  id?: string
  defaultWeatherIds?: number[]
  onChange: (weatherIds: number[]) => any
}

interface IWeatherSelectConnectProps {
  weathers: IWeather[]
}

const WeatherSelectFn = React.memo(
  ({ id, defaultWeatherIds, weathers, onChange }: IWeatherSelectConnectProps & IWeatherSelectProps): JSX.Element => {
    const [selectedWeatherIds, setSelectedWeatherIds] = React.useState<number[]>(defaultWeatherIds || [])
    id = id || "weathers-select"
    return (
      <FormControl id={id} sx={{ width: "100%" }} size="small">
        <InputLabel id={`${id}-label`}>{translate("report.group.sort.by.weather_id")}</InputLabel>
        <Select
          labelId={`${id}-label`}
          id={`${id}-input`}
          multiple
          value={selectedWeatherIds}
          onChange={event => {
            const newSelectedIds = event.target.value as number[]
            setSelectedWeatherIds(newSelectedIds)
            onChange(newSelectedIds)
          }}
          input={<OutlinedInput label={translate("report.group.sort.by.weather_id")} />}>
          {weathers.map((weather, index) => (
            <MenuItem id={id ? `${id}-option-${index}` : undefined} key={weather.weather_id} value={weather.id}>
              {translate(`label.weather.${weather.weather_id}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }
)

export const WeatherSelect = connect(
  (state: IRootState): IWeatherSelectConnectProps => ({
    weathers: state.schedule.weathers
  })
)(WeatherSelectFn)
